import React from 'react';
import { ASC, DataGridLayout, RelatedListWithSorting, RelationListLayout } from 'framework/list';
import CreateEmployeeContractButton from 'domain/people/employee/contracts/List/button/CreateEmployeeContractButton';
import EditEmployeeContractButton from 'domain/people/employee/contracts/List/button/EditEmployeeContractButton';
import ViewEmployeeContractButton from 'domain/people/employee/contracts/List/button/ViewEmployeeContractButton';
import { BadgeField, DateField, TextField } from 'framework/ui/field';
import EmployeeContractWillExpireSoonBadge from 'domain/people/contracts/shared/RelatedContractsList/badge/EmployeeContractWillExpireSoonBadge';
import { ActiveBadge, ExpiredBadge } from 'framework/ui/ui-builder';
import useContractsService from 'domain/people/contracts/shared/contractsService';
import { EmployeeOfficeField } from 'domain/shared/employee';
import ContractCategoryField from 'domain/people/contracts/shared/field/ContractCategoryField';
import ContractDurationField from 'domain/people/contracts/shared/field/ContractDurationField';
import ContractEndDateBadgeField from 'domain/people/contracts/shared/field/ContractEndDateBadgeField';
import useEmployeeContractsService, {
  UPDATE_EMPLOYEE_CONTRACT,
} from 'domain/people/employee/contracts/shared/employeeContractsService';
import { CONTRACTS_CONTEXT } from 'domain/people/employee/contracts/EmployeeContractsContext';
import { useAuthorization } from 'framework/authorization';

const RelatedContractsList = () => {
  const { search } = useEmployeeContractsService();
  const { isContractExpired, isContractWillExpireSoon, isContractActive } = useContractsService();

  const { isGranted } = useAuthorization();
  const canEdit = isGranted(UPDATE_EMPLOYEE_CONTRACT, CONTRACTS_CONTEXT);

  return (
    <RelatedListWithSorting getDataMethod={search} defaultSortField="dateOfSignature" defaultSortOrder={ASC}>
      <RelationListLayout actions={[<CreateEmployeeContractButton />]} header="Contracts" headerVariant="h4">
        <DataGridLayout
          isSmallTable
          buttons={[
            <EditEmployeeContractButton source="id" isVisible={canEdit} />,
            <ViewEmployeeContractButton source="id" />,
          ]}
          showTotal={false}
        >
          <TextField isSortable source="number" label="Contract number" width={150} />
          <DateField isSortable source="dateOfSignature" label="Date of signature" />
          <ContractDurationField dateFromSource="startDate" dateToSource="endDate" label="Contract duration" />
          <DateField isSortable source="startDate" label="Contract start date" />
          <BadgeField
            badges={[
              <EmployeeContractWillExpireSoonBadge
                id="expireSoon"
                isVisible={({ endDate }) => isContractWillExpireSoon(endDate)}
              />,
              <ActiveBadge
                id="activeContract"
                isVisible={({ startDate, endDate }) => isContractActive(startDate, endDate)}
              />,
              <ExpiredBadge id="expiredContract" isVisible={({ endDate }) => isContractExpired(endDate)} />,
            ]}
            isSortable
            source="endDate"
            label="Contract end date"
          >
            <ContractEndDateBadgeField />
          </BadgeField>
          <DateField isSortable source="probationPeriodEndedAt" label="Probation end date" />
          <ContractCategoryField source="secondary" label="Category" />
          <EmployeeOfficeField source="officeId" label="Office" />
        </DataGridLayout>
      </RelationListLayout>
    </RelatedListWithSorting>
  );
};

export default RelatedContractsList;
